"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.anonymousTrack = anonymousTrack;
var _uuid = require("uuid");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var UTM_TO_AMP_PROP = {
  utm_adgroup: 'utmAdGroup',
  utm_bu: 'utmBu',
  utm_network: 'utmNetwork',
  ut_source: 'utSource',
  ut_source2: 'utSource2',
  ut_source3: 'utSource3'
};
function extractUTParameters(eventData, url) {
  // Create Url Object for easier parsing
  var urlObject = new URL(url || '');

  // Extract the hostName
  var host = urlObject.hostname;
  eventData.hostName = host;

  // Extract ut params and add them to eventData
  var urlParams = urlObject.searchParams;
  for (var _key in UTM_TO_AMP_PROP) {
    if (urlParams.has(_key)) {
      eventData[UTM_TO_AMP_PROP[_key]] = urlParams.get(_key);
    }
  }
}
function anonymousTrack(config, event) {
  var _user$session, _window;
  var amplitudeToken = config.amplitudeToken,
    user = config.user;
  var data = event.data;
  var amplitudeEvent = data.amplitudeEvent,
    amplitudeUserProperties = data.amplitudeUserProperties;

  // Bail if no Amplitude token, admin impersonation, or no amplitude event in data
  if (!amplitudeToken || user !== null && user !== void 0 && (_user$session = user.session) !== null && _user$session !== void 0 && _user$session.isAdminImpersonation || !amplitudeEvent) {
    return;
  }

  // Make a shallow copy of the data to eventually send to Amplitude
  var eventData = _objectSpread({}, data);
  var amplitudeEventName = eventData.amplitudeEvent;

  // remove values we don't want to pass along as event properties
  delete eventData.amplitudeEvent;
  delete eventData.amplitudeUserProperties;
  delete eventData.actionType;
  delete eventData.actionFlow;

  // Add page viewed properties for a page viewed event
  if (amplitudeEvent.indexOf('page viewed') > -1 && !eventData.urlPath && typeof window === 'object' && typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.location) === 'object') {
    eventData.urlPath = window.location.pathname;
    extractUTParameters(eventData, window.location.href);
  }

  // Generate unique uuid for device ID
  var deviceId = (0, _uuid.v4)();

  // Send the event via beacon to avoid any built in cookie Action
  try {
    navigator.sendBeacon('https://api2.amplitude.com/2/httpapi', JSON.stringify({
      api_key: amplitudeToken,
      events: [{
        device_id: deviceId,
        user_id: '',
        event_type: amplitudeEventName,
        event_properties: eventData,
        user_properties: amplitudeUserProperties
      }]
    }));
  } catch (error) {
    console.error(error);
  }
}